import React from 'react';
import { PrintActionButton } from '../../../components/sub-header/actions/PrintActionButton';
import { ShareActionButton } from '../../../components/sub-header/actions/ShareActionButton';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { detectUserAgent } from '../../../utils/userAgentUtils';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';

type Props = {
  name: string;
  source: string;
} & UserContextType;

function RawLawFirmActions({ name, accessPremium, source }: Props) {
  const textToCopy = () => {
    const profileUrl = `${window.location.origin}${window.location.pathname}`;
    return `Page du cabinet ${name}. Voir en ligne : ${profileUrl}`;
  };

  const sendPrintAnalytics = () =>
    doctrineAnalytics('LawFirm ButtonPrintClicked');

  const sendShareAnalytics = () =>
    doctrineAnalytics('LawFirm ButtonCopyClicked');

  return (
    <div className="button-group no-gaps clear secondary">
      {detectUserAgent() !== 'Mozilla Firefox' && (
        <PrintActionButton
          accessPremium={accessPremium}
          sendAnalytics={sendPrintAnalytics}
          source={source}
        />
      )}
      <ShareActionButton
        source={source}
        text={textToCopy()}
        sendAnalytics={sendShareAnalytics}
      />
    </div>
  );
}

export const LawFirmActions = withUser(RawLawFirmActions);
